<div
    class="sb-snackbar-container"
    [ngClass]="{ 'sb-snackbar-layout-stacked': layout === SnackbarLayout.B, 'sb-snackbar-layout-inline': layout === SnackbarLayout.A }">


    @if (layout === SnackbarLayout.A) {
        <ng-container *ngTemplateOutlet="label"></ng-container>

        <div class="sb-snackbar-action">
            <ng-container *ngTemplateOutlet="action"></ng-container>
        </div>

        <ng-container *ngTemplateOutlet="close"></ng-container>
    } @else {
        <div class="sb-snackbar-layout-stacked-inline">
            <ng-container *ngTemplateOutlet="label"></ng-container>
            <ng-container *ngTemplateOutlet="close"></ng-container>
        </div>
             <div class="sb-snackbar-long-action">
            <ng-container *ngTemplateOutlet="action"></ng-container>
        </div>

    }
</div>

<ng-template #action>
    <ng-content select="[actions]"></ng-content>
</ng-template>

<ng-template #label>
    <div class="sb-snackbar-label-wrapper"   [attr.data-sb-qa]="qaTag ? qaTag : ''">
        <ng-content select="[message]"></ng-content>
    </div>
</ng-template>

<ng-template #close>
    <div class="sb-snackbar-close">
        <ng-content select="[close]"></ng-content>
    </div>
</ng-template>
